angular.module('app').controller('EventCtrl', function($scope, $controller, $http, $mdToast, $mdDialog, $rootScope, dragulaService, adminTableDragMirror, appUtils, $location, $timeout, saveNavigationState) {
    "ngInject";
    var main = this;

    var accordionState = saveNavigationState.take();

    $scope.$on('adminAccordion:initialize', function(event, state) {
        if (Object.prototype.hasOwnProperty.call(accordionState, state.title)) {
            state.expanded = accordionState[state.title];
            delete accordionState[state.title];
        }
    });

    main.beforeSaveNavigation = function(response, destinationUrl) {
        var state = {};
        $scope.$broadcast('adminAccordion:collectState', state);
        saveNavigationState.remember(destinationUrl, state);
    };

    main.revenueRates = {};

    main.expandAllAccordions = function() {
        $scope.$broadcast('adminAccordion:expandAll');
    };

    main.collapseAllAccordions = function() {
        $scope.$broadcast('adminAccordion:collapseAll');
    };

    // Fetch revenue rates from API
    $http.get('/api/v1/admin/event/revenue-rates').then(function(response) {
        main.revenueRates = response.data;
    });

    main.name = 'event';
    main.defaults = {
        'default_moods': true,
        'enable_signups': true,
        'require_login_for_gallery': false,
        'copyright_notice': 'test',
        'set_up_time': '2019-01-01 07:00',
        'late_signup_message': 'This close to Picture Day we may have already sent the list of registrations to the school. Please let %(school_contact)s know you registered. Thank you!',
        'start_time': '2019-01-01 08:00',
        'allow_school_shipping': true,
        'allow_home_shipping': true,
        'home_shipping_fee': 10,
        'moods': [],
        'deliverables': [
            {'name': 'Deliver Marketing Materials'},
            {'name': 'Send Electronic Marketing'},
            {'name': 'Post Proofs'},
            {'name': 'Send to Lab'},
            {'name': 'Deliver to School'},
        ],
        'confirmed': true,
        'show_on_website': true,
        'photo_days': [],
        'shifts': [],
        'notifications': [
            {'name': 'Portrait Sessions Coming Soon', 'type': 'coming', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_coming_soon'},
            {'name': 'Director Follow Up (4 days after posting)', 'type': 'nonviewed', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_nonviewed_followup_template'},
            {'name': 'Periodic Reminder', 'type': 'periodic', 'enabled': true, 'config': {'frequency': 3, 'protected': true}, 'default_template': 'default_periodic_reminder_template'},
            {'name': 'Final Reminder', 'type': 'final', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_final_reminder_template'},
            {'name': 'Non-ordered Survey', 'type': 'nonorder', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_non_order_survey_template'},
            {'name': 'You Have More Time to Order', 'type': 'moretime', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_more_time_template'},
            {'name': 'Reminder - Last Chance - Late Order Due Date', 'type': 'late_closing', 'enabled': true, 'config': {'protected': true}, 'default_template': 'default_late_closing_template'}
        ],
        'event_question_relationships': [],
        'event_incentives': [],
        'email_flex_variables': [],
        'subject_lookup_instructions': 'If you do not have an access code, enter your subject\'s details below to view your gallery.'
    };
    main.copyCollections = [
        {'name': 'notifications', 'key': 'id'},
        {'name': 'event_question_relationships', 'key': 'id'},
        {'name': 'shifts', 'key': 'id'},
        {'name': 'shifts', 'key': 'when_i_work_id'},
        {'name': 'deliverables', 'key': 'id'},
        {'name': 'deliverables', 'key': 'completed_at'},
        {'name': 'deliverables', 'key': 'due_date'},
    ];


    main.default_shift_start = new Date();
    main.default_shift_start_time = '07:00:00';
    main.default_shift_end_time = '13:00:00';

    main.photographer_shifts = 1;
    main.assistant_shifts = 1;
    main.runner_shifts = 0;

    main.addDefaultShifts = function() {
        var types = [
            {'var_name': 'photographer_shifts', 'label': 'Photographer'},
            {'var_name': 'assistant_shifts', 'label': 'Assistant'},
            {'var_name': 'runner_shifts', 'label': 'Runner'},
        ];
        
        // Find the maximum number of shifts to add
        var maxShifts = Math.max(
            main.photographer_shifts || 0,
            main.assistant_shifts || 0,
            main.runner_shifts || 0
        );
        
        // Add shifts in interleaved order
        for(var i = 0; i < maxShifts; i++) {
            types.forEach(function(type) {
                if(i < main[type.var_name]) {
                    var shift = {
                        date: angular.copy(main.default_shift_start),
                        start_time: angular.copy(main.default_shift_start_time),
                        end_time: angular.copy(main.default_shift_end_time),
                        position: type.label
                    };
                    
                    // Set the default commission for photographers based on franchise setting
                    if(type.label === 'Photographer' && main.franchise && main.franchise.default_photographer_commission) {
                        shift.commission = main.franchise.default_photographer_commission;
                    }
                    
                    main.item.shifts.push(shift);
                }
            });
        }
    }

    if($location.search().copy) {
        $scope.$on('model-copied', function() {
            delete main.item.wordpress_post_id;
            delete main.item.marketing_material_delivered;
            delete main.item.electronic_marketic_done;
            delete main.item.proofs_posted;
            delete main.item.sent_to_lab;
            delete main.item.delivered_to_school;
            delete main.item.actual_post_date;
            delete main.item.start_date;
            delete main.item.end_date;
            delete main.item.marketing_due_date;
            delete main.item.second_flyer_due_date;
            delete main.item.signup_deadline;
            delete main.item.expected_post_date;
            delete main.item.orders_due_date;
            delete main.item.grace_period_ends;
            delete main.item.expected_delivery_date;
            delete main.item.late_orders_close;
        });
    }

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.userSearch = function(search) {
        var query = appUtils.filter({'name': 'franchise_id', 'val': main.item.school.franchise_id || $rootScope.franchiseSwitcher.activeFranchise(), 'op': 'eq'});
        query.q.filters.push({'name': 'all_customers', 'val': true})
        return appUtils.orSearch('user', ['first_name', 'last_name', 'email'], search, query);
    };
    
    // Update commission rate when a user is assigned to a shift
    main.updateShiftCommission = function(shift) {
        if (shift.position !== 'Photographer') {
            return;
        }

        if (shift.user && shift.user.default_commission) {
            shift.commission = shift.user.default_commission;
        } else if (main.franchise.default_photographer_commission) {
            shift.commission = main.franchise.default_photographer_commission;
        }
    };

    main.isDefaultDeliverable = $rootScope.isDefaultDeliverable;

    main.save = function() {
        // Check if at least one photographer shift exists
        const hasPhotographerShift = main.item.shifts && main.item.shifts.some(shift => shift.position === 'Photographer');
        if (!hasPhotographerShift) {
            appUtils.toast('At least one Photographer shift is required.', 'error-toast');
            $scope.$broadcast('adminAccordion:expand', 'Shifts');
            $timeout(() => {
                const shiftsSection = document.querySelector('.admin-event-shifts-accordion');
                if (shiftsSection) {
                    shiftsSection.scrollIntoView({'behavior': 'smooth'});
                    document.querySelector('.main').scrollBy(0, -100);
                }
            }, 1);
            return false;
        }

        // Check if any shifts or photo_days fall outside the event date range
        const startDate = moment(main.item.start_date).startOf('day');
        const endDate = moment(main.item.end_date).endOf('day');
        let datesOutsideRange = [];
        
        // Check shifts
        if (main.item.shifts && main.item.shifts.length > 0) {
            main.item.shifts.forEach(function(shift, index) {
                if (shift.date) {
                    const shiftDate = moment(shift.date).startOf('day');
                    if (shiftDate.isBefore(startDate) || shiftDate.isAfter(endDate)) {
                        datesOutsideRange.push({
                            type: 'shift',
                            index: index + 1,
                            date: moment(shift.date).format('MM/DD/YYYY'),
                            position: shift.position || 'Unknown'
                        });
                    }
                }
            });
        }
        
        // Check photo_days
        if (main.item.photo_days && main.item.photo_days.length > 0) {
            main.item.photo_days.forEach(function(day, index) {
                if (day.date) {
                    const photoDate = moment(day.date).startOf('day');
                    if (photoDate.isBefore(startDate) || photoDate.isAfter(endDate)) {
                        datesOutsideRange.push({
                            type: 'photo_day',
                            index: index + 1,
                            date: moment(day.date).format('MM/DD/YYYY')
                        });
                    }
                }
            });
        }
        
        // If we found dates outside the range, show confirmation dialog
        if (datesOutsideRange.length > 0) {
            let message = '<p>The following dates fall outside the event date range (<strong>' + 
                startDate.format('MM/DD/YYYY') + '</strong> to <strong>' + endDate.format('MM/DD/YYYY') + '</strong>):</p>';
            
            message += '<ul style="padding-left: 20px;">';
            datesOutsideRange.forEach(function(item) {
                if (item.type === 'shift') {
                    message += '<li><strong>Shift #' + item.index + '</strong> (' + item.position + '): ' + item.date + '</li>';
                } else {
                    message += '<li><strong>Photo Day #' + item.index + '</strong>: ' + item.date + '</li>';
                }
            });
            message += '</ul>';
            
            message += '<p>Do you want to continue saving?</p>';
            
            const confirm = $mdDialog.confirm()
                .title('Date Range Warning')
                .htmlContent(message)
                .ariaLabel('Date Range Warning')
                .ok('Continue')
                .cancel('Cancel');
                
            $mdDialog.show(confirm).then(function() {
                // User clicked Continue, proceed with save
                main.processSaveAndContinue();
            }, function() {
                // User clicked Cancel, do nothing
            });
        } else {
            // No dates outside range, proceed with save
            main.processSaveAndContinue();
        }
    };
    
    main.processSaveAndContinue = function() {
        main.item.deliverables.forEach(function(deliverable) {
            mapping = $rootScope.default_deliverables[deliverable.name];
            if(mapping) {
                if(mapping.due) {
                    main.item[mapping.due] = deliverable.due_date;
                }

                if(mapping.complete) {
                    main.item[mapping.complete] = deliverable.completed_at;
                }
            }
        });

        if ($scope.itemForm && $scope.itemForm.$invalid) {
            var invalidControl = document.querySelector('.admin-event-page-form .ng-invalid');
            var invalidAccordion = invalidControl && invalidControl.closest('admin-accordion');

            if (invalidAccordion) {
                $scope.$broadcast('adminAccordion:expand', invalidAccordion.getAttribute('title'));
            }
        }

        var saving = main._save();
        if(saving && saving.then) {
            saving.then(function(response) {
                ((response.data || {}).when_i_work_warnings || []).forEach(function(warning) {
                    $mdToast.show($mdToast.simple().textContent(warning).hideDelay(6000));
                });
            });
        }
    }

    main.editDays = function() {
        $rootScope.util.quickDialog(
            function(dragulaService) {
                var dialogScope = this;
                dragulaService.options(dialogScope.$scope, 'photo_days', {
                    'moves': function(el, container, handle) {
                        return handle.classList.contains('handle');
                    }
                });
                adminTableDragMirror.register(dialogScope.$scope, 'photo_days');
                dialogScope.done = function() {
                    main.item.photo_days.forEach(function(day) {
                        dateObj = moment.parseZone(day.date, null, true);
                        if(typeof day.date != 'undefined' && dateObj.isValid()) {
                            day.date = dateObj.format('YYYY-MM-DD');
                        }
                    });
                    $mdDialog.hide();
                    if($scope.itemForm.$valid) {
                        main.save();
                    }
                };
                dialogScope.addDay = function() {
                    dialogScope.item.photo_days.push({
                        'id': new Date().getTime()
                    });
                }
                if(main.id != 'new') {
                    $http({'method': 'GET', 'url': '/api/v1/admin/event/' + main.id + '/day-count'}).then(
                        function(response) {
                            dialogScope.day_count = response.data;
                        }
                    );
                }
            },
            'edit-days.html',
            { item: main.item }
        );
    };

    dragulaService.options($scope, 'questions', {
        'moves': function(el, container, handle) {
            return handle.classList.contains('handle');
        }
    });
    adminTableDragMirror.register($scope, 'questions');

    dragulaService.options($scope, 'shifts', {
        'moves': function(el, container, handle) {
            return handle.classList.contains('handle');
        }
    });
    adminTableDragMirror.register($scope, 'shifts');

    main.sent_to_lab_expected = function() {
        return moment(main.item.orders_due_date).clone().add(3, 'd').format('MM/DD/Y');
    };

    main.barcode = function(){
        $rootScope.util.quickDialog(
            'BarcodeChoiceCtrl',
            'barcode-choice.html',
            {'id': main.id}
        );
    };

    main.stickerReport = function(){
        $rootScope.util.quickDialog(
            function($scope) {
                $scope.choice = '8';
                $scope.download = function() {
                    top.location = `/api/v1/admin/event/${main.item.id}/sticker-report?format=${$scope.choice}`;
                    $mdDialog.hide();
                };
            },
            'sticker-choice.html'
        );
    };

    if(main.id == 'new' && !$location.search().copy) {
        $http({
            'url': '/api/v1/admin/event_question',
            'method': 'GET',
            'params': {'q': {'filters': [{'name': 'default', 'op': 'eq', 'val': true}]}}
        }).then(
            function(response) {
                main.item.event_question_relationships = response.data.objects.map(function(obj) {
                    return {'question': obj};
                });
            }
        );

        var loadFranchiseData = function() {
            $http({
                'url': '/api/v1/admin/franchise/' + $rootScope.franchiseSwitcher.activeFranchise(),
                'method': 'GET',
            }).then(
                function(response) {
                    main.franchise = response.data;
                    main.item.notifications.forEach((notification) => {
                        notification.template = response.data[notification.default_template];
                        delete notification['default_template'];
                    });
                    main.item.registration_receipt = response.data.default_registration_receipt;
                    main.item.order_receipt = response.data.default_order_receipt;
                    main.has_when_i_work_token = response.data.has_when_i_work_token;
                    if(response.data.default_late_signup_message) {
                        main.item.late_signup_message = response.data.default_late_signup_message;
                    }

                }, function() {
                    main.item.notifications.forEach((notification) => {
                        delete notification['default_template'];
                    });
                }
            );
        }

        if($rootScope.franchise_id) {
            loadFranchiseData();
        } else {
            $scope.$on('permissions-saved', loadFranchiseData);
        }
    } else {
        var loadFranchiseData = function() {
            $http({
                'url': '/api/v1/admin/franchise/' + $rootScope.franchiseSwitcher.activeFranchise(),
                'method': 'GET',
            }).then(
                function(response) {
                    main.franchise = response.data;
                    main.has_when_i_work_token = response.data.has_when_i_work_token;
                }
            );
        }
        if($rootScope.franchise_id) {
            loadFranchiseData();
        } else {
            $scope.$on('permissions-saved', loadFranchiseData);
        }
    }

    main.syncShifts = function() {
        $http.post('/api/v1/admin/event/' + main.id + '/sync-shifts', main.item).then(function(response) {
            main.syncingToWIW = true;
            main.item.shifts = response.data.shifts;
            (response.data.warnings || []).forEach(function(warning) {
                $mdToast.show($mdToast.simple().textContent(warning).hideDelay(6000));
            });
        });
    }

    main.hasSyncedShifts = function() {
        if(main.syncingToWIW) {
            return true;
        }
        return main.item.shifts.some(shift => {
            return shift.id != null && shift.when_i_work_id != null;
        });
    };

    main.recreateWPPost = function() {
        var confirm = $mdDialog.confirm()
            .title('Recreate Blog Post')
            .textContent('Are you sure you want to recreate the blog post? This will replace any existing post.')
            .ariaLabel('Recreate blog post')
            .ok('Yes, recreate')
            .cancel('Cancel');

        $mdDialog.show(confirm).then(function() {
            $http.post('/api/v1/admin/event/' + main.id + '/recreate-wp-post').then(
                function(response) {
                    main.item.wordpress_post_id = response.data.id;
                    var alert = $mdToast.simple().textContent("Recreated post");
                    $mdToast.show(alert);
                    return;
                }
            );
        });
    };

    main.addExistingQuestion = function(question) {
        if(!question || !question.id) {
            return;
        }

        var ids = main.item.event_question_relationships.map(function(eqr) {
            return eqr.question.id;
        });

        main.questionToAdd = null;

        if(ids.includes(question.id)) {
            var alert = $mdToast.simple().textContent("That question is already included.");
            $mdToast.show(alert);
            return;
        }

        main.item.event_question_relationships.push({
            'question': question
        });
    };

    main.addIncentive = function(incentive) {
        if(!incentive || !incentive.id) {
            return;
        }

        main.incentiveToAdd = null;

        if(main.item.event_incentives.length > 0) {
            var alert = $mdToast.simple().textContent("Only one incentive per event is allowed. Remove the existing incentive first.");
            $mdToast.show(alert);
            return;
        }

        main.item.event_incentives.push({
            'incentive': incentive,
            'incentive_id': incentive.id,
            'expiration_date': null
        });
    };

    main.addNewQuestion = function() {

        return $mdDialog.show({
            'controller': 'OptionCtrl',
            'controllerAs': 'main',
            'templateUrl': 'option.html',
            'multiple': true,
            'locals': {
                'id': 'new',
                'embedded': true,
                'from': 'event',
                'option': {'options': {'choices': []}}
            },
            'bindToController': true
        }).then(
            function(item) {
                main.item.event_question_relationships.push({
                    'question': {
                        'franchise_id': $rootScope.franchise_id,
                        'name': item.options.name,
                        'type': item.options.type,
                        'options': item.options
                    }
                });
            }
        );
    };

    main.editOption = function(item) {
        if(!item.question.options) {
            item.question.options = {
                'name': item.question.name,
                'type': item.question.type,
                'choices': []
            }
        }
        return $mdDialog.show({
            'controller': 'OptionCtrl',
            'controllerAs': 'main',
            'templateUrl': '/static/admin/templates/option.html',
            'multiple': true,
            'locals': {
                'id': item.question_id,
                'embedded': true,
                'from': 'event',
                'option': item.question
            },
            'bindToController': true
        }).then(
            function(question) {
                item.question.name = question.options.name;
                item.question.admin_name = question.options.admin_name;
                item.question.type = question.options.type;
                item.question.options = question.options;
            }
        );
    };

    main.adjustEndDates = function(oldVal) {
        var dates = [
            {'name': 'Post Proofs', 'days': 7, 'type': 'deliverable'},
            {'name': 'orders_due_date', 'days': 13, 'type': 'date'},
            {'name': 'Send to Lab', 'days': 16, 'type': 'deliverable'},
            {'name': 'grace_period_ends', 'days': 14, 'type': 'date'},
            {'name': 'Deliver to School', 'days': 43, 'type': 'deliverable'},
            {'name': 'late_orders_close', 'days': 103, 'type': 'date'},
        ];

        var oldEnd = moment(oldVal);
        var newEnd = moment(main.item.end_date);

        main.adjustDates(dates, oldEnd, newEnd);
    };

    main.adjustStartDates = function(oldVal) {

        if(main.item.enable_signups) {
            var marketing_due_date = -21;
        } else {
            var marketing_due_date = -14;
        }

        var dates = [
            {'name': 'Deliver Marketing Materials', 'days': marketing_due_date, 'type': 'deliverable' },
            {'name': 'Send Electronic Marketing', 'days': marketing_due_date, 'type': 'deliverable' },
            {'name': 'signup_deadline', 'days': -7, 'type': 'date' },
            {'name': 'end_date', 'days': 0, 'type': 'date' },
        ];

        var oldStart = moment(oldVal);
        var newStart = moment(main.item.start_date);
        var oldEnd = main.item.end_date;

        main.default_shift_start.setMonth(newStart.month());
        main.default_shift_start.setDate(newStart.date());
        main.default_shift_start.setYear(newStart.year());
        main.default_shift_start = angular.copy(main.default_shift_start);


        main.adjustDates(dates, oldStart, newStart);
        main.adjustEndDates(oldEnd);
    };

    main.adjustDates = function(dates, oldDate, newDate) {

        dates.forEach((date) => {
            var targetInterval = date.days;

            if(date.type == 'deliverable') {
                var deliverable = main.item.deliverables.find(d => d.name == date.name);
                if(typeof deliverable.due_date === 'undefined' || deliverable.due_date === null) {
                    deliverable.due_date = newDate.clone().add(targetInterval, 'days').toDate();
                    return;
                }

                var targetDay = oldDate.clone();
                targetDay.add(targetInterval, 'days');
                var curDay = moment(deliverable.due_date);

                if(targetDay.isSame(curDay, 'day')) {
                    deliverable.due_date = newDate.clone().add(targetInterval, 'days').toDate();
                }
            } else {
                if(typeof main.item[date.name] === 'undefined' || main.item[date.name] === null) {
                    main.item[date.name] = newDate.clone().add(targetInterval, 'days').toDate();
                    return;
                }

                var targetDay = oldDate.clone();
                targetDay.add(targetInterval, 'days');
                var curDay = moment(main.item[date.name]);

                if(targetDay.isSame(curDay, 'day')) {
                    main.item[date.name] = newDate.clone().add(targetInterval, 'days').toDate();
                }
            }
        });
    };

    main.default_equipment_lists = false;

    main.doEquipmentListUpdate = function(oldVal) {
        if(
            typeof main.item.equipment_list === 'undefined' ||
            main.item.equipment_list === null ||
            main.item.equipment_list === main.default_equipment_lists[oldVal]
        ) {
            main.item.equipment_list = main.default_equipment_lists[main.item.session_type];
        }
    };

    main.checkDefaultSet = function(oldVal) {
        console.log(oldVal);
        var defaultSet = $rootScope.session_types[main.item.session_type].find((set) => { return set.default });
        if(defaultSet) {
            console.log('defSet', defaultSet);
            main.item.session_set_id = defaultSet.id;
            main.item.session_set = defaultSet;
            return;
        }
        var noSet = $rootScope.session_types[main.item.session_type].find((set) => { return set.name == null || set.name == '' });
        if(noSet) {
            console.log('noSet', noSet);
            main.item.session_set_id = noSet.id;
            main.item.session_set = noSet;
            return;
        }


        console.log('clear set');
        main.item.session_set_id = null;
        delete main.item.session_set;
    }

    main.updateEquipmentList = function(oldVal) {
        if(!main.default_equipment_lists) {
            $http({
                'url': '/api/v1/admin/franchise/' + $rootScope.franchiseSwitcher.activeFranchise(),
                'method': 'GET'
            }).then(
                function(response) {
                    main.default_equipment_lists = response.data.default_equipment_lists;
                    main.doEquipmentListUpdate(oldVal);
                }
            );
        } else {
            main.doEquipmentListUpdate(oldVal);
        }
    };

    main.loadMoods = function() {
        $http({
            'url': '/api/v1/admin/mood?results_per_page=1000',
            'method': 'GET'
        }).then(
            function(response) {
                main.moods = response.data.objects;
            }
        );
    };

    $scope.$on('model-loaded', function() {
        if(!main.item.default_moods) {
            main.loadMoods();
        }

        if(!main.item.photo_days) {
            main.item.photo_days = [];
        }

        if(main.item.start_date) {
            main.default_shift_start = moment(main.item.start_date).toDate();
        }

        main.item.deliverables.sort(function(a, b) { 
            if( typeof b.due_date == 'undefined' || b.due_date == null) {
                return -1;
            }

            if(typeof a.due_date == 'undefined' || a.due_date == null) {
                return 1;
            }

            return moment(a.due_date) - moment(b.due_date);
        });
        main.item.deliverables = main.item.deliverables;
    });

    // Watch for changes to enable_signups to auto-toggle require_login_for_gallery
    $scope.$watch('main.item.enable_signups', function(newVal, oldVal) {
        if (newVal === true && oldVal === false) {
            main.item.require_login_for_gallery = true;
        }
    });

    main.editNotification = function(notification) {
        return $rootScope.util.quickDialog(
            'NotificationCtrl',
            '/static/admin/templates/notification.html',
            {'item': notification, 'embedded': true, 'load': () => {} }
        );
    }
    
    main.addNotification = function() {
        main.editNotification({'type': 'custom', 'enabled': true}).then(function(notification) {
            main.item.notifications.push(notification);
        });
    }

});
